module.exports = __webpack_public_path__ + "img/bjxsky2.d5b68a67.jpg";